export function constructClassificationHierarchy(data) {
    let hierarchicalName = "";
    if(data.parent != null){
        return this.constructClassificationHierarchy(data.parent) + ' → ' + data.name + hierarchicalName;
    } else {
        return data.name + hierarchicalName;
    }
}
